// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import SocialSharing from 'vue-social-sharing';
import PlayerCdn from 'playerCdn';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap';
import router from './router/routesEmbed';
import AppEmbed from './AppEmbed';
import Default from './layouts/Default.vue';
import store from './store';

import en from './i18n/en_US.js';
import fr from './i18n/fr_FR.js';
Vue.use(VueI18n);
let locale = process.env.LANGUAGE ? process.env.LANGUAGE : 'fr';

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: locale, // set locale
  messages: {
    en: en,
    fr: fr,
  },
});
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(PlayerCdn);
Vue.use(SocialSharing);
Vue.component('default-layout', Default);
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#embed',
  i18n,
  router,
  render: h => h(AppEmbed),
  store,
});



// WEBPACK FOOTER //
// ./src/main_embed.js